import React from 'react';
import { css } from 'emotion';
import { brandYellow, background } from '@guardian/src-foundations/palette';
import { headline, textSans } from '@guardian/src-foundations/typography';
import { space } from '@guardian/src-foundations';
import { until } from '@guardian/src-foundations/mq';
import { Score } from '@frontend/web/components/Score';
const Row = ({ children }) => (React.createElement("div", { className: css `
            display: flex;
            flex-direction: row;
        ` }, children));
const CrestRow = ({ children }) => (React.createElement("div", { className: css `
            display: flex;
            flex-direction: row;
            align-items: flex-end;
        ` }, children));
const StretchBackground = ({ children }) => (React.createElement("div", { className: css `
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            position: relative;
            padding: ${space[2]}px;
            background-color: ${brandYellow.main};

            :before {
                content: '';
                position: absolute;
                top: 0;
                bottom: 0;
                width: 100vw;
                left: -100vw;
                ${until.desktop} {
                    left: calc((100vw - 46rem) / -2);
                }
                background-color: ${brandYellow.main};
                z-index: -1;
            }
        ` }, children));
const Column = ({ children }) => (React.createElement("div", { className: css `
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        ` }, children));
const TeamName = ({ name }) => (React.createElement("h2", { className: css `
            ${headline.xxsmall({ fontWeight: 'bold' })}
        ` }, name));
const Scorers = ({ scorers }) => (React.createElement("ul", { className: css `
            margin-top: ${space[1]}px;
            margin-bottom: ${space[3]}px;
        ` }, scorers.map(player => (React.createElement("li", { className: css `
                    ${textSans.small()}
                ` }, player)))));
const Crest = ({ crest }) => (React.createElement("div", { className: css `
            position: relative;
            width: 3.75rem;
            height: 3.75rem;
            border-radius: 1.875rem;
            background-color: ${background.primary};
            z-index: 1;
        ` },
    React.createElement("img", { className: css `
                position: absolute;
                left: 0.5rem;
                right: 0.5rem;
                bottom: 0.5rem;
                top: 0.5rem;
                max-width: calc(100% - 1rem);
                max-height: calc(100% - 1rem);
                margin: auto;
                display: block;
            `, src: crest, alt: "" })));
const TeamNav = ({ name, score, crest, scorers, }) => (React.createElement("div", { className: css `
            display: flex;
            flex-grow: 1;
        ` },
    React.createElement(Column, null,
        React.createElement("div", { className: css `
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                ` },
            React.createElement(TeamName, { name: name }),
            React.createElement(Scorers, { scorers: scorers })),
        React.createElement(CrestRow, null,
            React.createElement(Crest, { crest: crest }),
            React.createElement("div", { className: css `
                        margin-left: -${space[2]}px;
                    ` },
                React.createElement(Score, { score: score }))))));
const Comments = ({ comments }) => (React.createElement("div", { className: css `
            ${textSans.small()}
            margin-top: ${space[2]}px;
            padding-top: ${space[1]}px;
            font-style: italic;
            /* stylelint-disable-next-line color-no-hex */
            border-top: 1px solid #d0bb04;
        ` }, comments));
const Border = () => (React.createElement("div", { className: css `
            /* stylelint-disable-next-line color-no-hex */
            border-left: 1px solid #d0bb04;
            margin-left: ${space[1]}px;
            width: ${space[2]}px;
        ` }));
export const MatchNav = ({ homeTeam, awayTeam, comments }) => (React.createElement(StretchBackground, null,
    React.createElement(Row, null,
        React.createElement(TeamNav, { name: homeTeam.name, score: homeTeam.score, crest: homeTeam.crest, scorers: homeTeam.scorers }),
        React.createElement(Border, null),
        React.createElement(TeamNav, { name: awayTeam.name, score: awayTeam.score, crest: awayTeam.crest, scorers: awayTeam.scorers })),
    comments && React.createElement(Comments, { comments: comments })));
